import { render } from "./NavbarPrfileMenu.vue?vue&type=template&id=53566ce8"
import script from "./NavbarPrfileMenu.vue?vue&type=script&lang=js"
export * from "./NavbarPrfileMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__